module.exports = __webpack_public_path__ + "img/social_media_zhihu.d4d64b64.png";